import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import AppLayout from './layouts/AppLayout.jsx'
import ProtectedRoute from './components/ProtectedRoute.jsx'
import AuthInitializer from './components/AuthInitializer.jsx'
import AuthErrorBoundary from './components/AuthErrorBoundary.jsx'
import LoadingSpinner from './components/LoadingSpinner.jsx'

const Login = lazy(() => import('./pages/Login.jsx'))
const SignUp = lazy(() => import('./pages/SignUp.jsx'))
const Dashboard = lazy(() => import('./pages/Dashboard.jsx'))
const VehicleList = lazy(() => import('./pages/VehicleList.jsx'))
const VehicleDetail = lazy(() => import('./pages/VehicleDetail.jsx'))
const AddVehicle = lazy(() => import('./pages/AddVehicle.jsx'))
const EditVehicle = lazy(() => import('./pages/EditVehicle.jsx'))
const MOTHistory = lazy(() => import('./pages/MOTHistory.jsx'))
const Insurance = lazy(() => import('./pages/Insurance.jsx'))
const RepairHistory = lazy(() => import('./pages/RepairHistory.jsx'))
const Expenses = lazy(() => import('./pages/Expenses.jsx'))
const FuelTracking = lazy(() => import('./pages/FuelTracking.jsx'))
const Analytics = lazy(() => import('./pages/Analytics.jsx'))
const Profile = lazy(() => import('./pages/Profile.jsx'))
const Invitations = lazy(() => import('./pages/Invitations.jsx'))
const Subscription = lazy(() => import('./pages/Subscription.jsx'))
const BillingHistory = lazy(() => import('./pages/BillingHistory.jsx'))

export default function Router() {
  return (
    <Suspense fallback={<div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center"><LoadingSpinner /></div>}>
      <Routes>
        <Route path="/login" element={<AuthErrorBoundary><Login /></AuthErrorBoundary>} />
        <Route path="/signup" element={<AuthErrorBoundary><SignUp /></AuthErrorBoundary>} />

        <Route
          element={
            <ProtectedRoute>
              <AuthInitializer>
                <AppLayout />
              </AuthInitializer>
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<Dashboard />} />
          <Route path="/vehicles" element={<VehicleList />} />
          <Route path="/vehicles/add" element={<AddVehicle />} />
          <Route path="/vehicles/:vehicleUuid" element={<VehicleDetail />} />
          <Route path="/vehicles/:vehicleUuid/edit" element={<EditVehicle />} />
          <Route path="/vehicles/:vehicleUuid/mot" element={<MOTHistory />} />
          <Route path="/vehicles/:vehicleUuid/insurance" element={<Insurance />} />
          <Route path="/vehicles/:vehicleUuid/repairs" element={<RepairHistory />} />
          <Route path="/vehicles/:vehicleUuid/fuel" element={<FuelTracking />} />
          <Route path="/expenses" element={<Expenses />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/invitations" element={<Invitations />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/billing-history" element={<BillingHistory />} />
        </Route>

        {/* Defensive catch-all so unknown URLs no longer render an unrouted blank
            screen (which previously also broke Auth0's transaction state). */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Suspense>
  )
}
